<template>
  <patient-profile>
    <modal-dialog
      v-model="isSelectContractNumberModal"
      content-class="contract-number-modal"
      title="Выберите номер договора"
      with-cross
      max-width="600px"
    >
      <select-contract-number-modal
        ref="contractSelector"
        v-bind:contracts="patientContracts"
        v-on:on-submit="onSelectContractNumber"
        v-on:on-close="onCloseSelectModal"
      />
    </modal-dialog>
    <modal-dialog
      v-model="isShownNdflCertificateOptionForm"
      title="Справка для налоговой"
      with-cross
    >
      <form
        class="patient-documents__ndfl-options"
        v-on:submit.prevent="onSubmitNdflCertificateOptionsForm"
      >
        <div class="patient-documents__ndfl-options__list">
          <button
            class="patient-documents__ndfl-options__year"
            type="button"
            v-bind:class="{ selected: isSelected }"
            v-bind:key="year"
            v-for="{ year, isSelected } in reportingYears"
            v-on:click="selectedReportingYear = year">{{ year }}</button>
        </div>
        <div class="patient-documents__ndfl-options__list">
          <button
            class="patient-documents__ndfl-options__type"
            type="button"
            v-bind:class="{ selected: isSelected }"
            v-bind:key="value"
            v-for="{ name, value, isSelected } in reportingTypes"
            v-on:click="selectedReportingType = value">{{ name }}</button>
        </div>
        <button
          class="patient-documents__button-make"
          type="submit">Сформировать</button>
      </form>
    </modal-dialog>
    <picker-items
      class="picker"
      content-class="documents-dialog"
      width="800px"
      v-bind:items="templates"
      title="Выберите документ"
      v-model="shownTemplatePicker"
      v-on:add="onAddTemplate"
      v-on:search="fetchTemplates"
      v-on:open="onResetBacklightTheButtons"
    >
      <template
        v-if="shownHeaderDocumentPicker"
        v-slot:header
      >
        <strong v-if="patientUnderFifteen" class="documents-dialog__warning">
          Для пациентов младше 15&nbsp;лет документы может подписывать только законный представитель
        </strong>
        <div v-if="hasBranchSystem" class="documents-dialog__general-document">
          <input-checkbox
            class="documents-dialog__checkbox"
            name="general-document"
            title="Сделать документ общим для всех филиалов"
            v-model="showAllBranches"
          />
          <div class="documents-dialog__help">
            <help-icon
              bottom
              type-icon="question"
              v-bind:max-width="260"
              v-bind:tooltip-text="$options.helpTextGlobalDocument"
            />
          </div>
        </div>
      </template>
      <template
        v-slot:default="{
          item,
          emitAdd,
          onSelectSetColor,
        }">
        <button
          class="picker__item__button"
          type="button"
          :data-id="item.id"
          :data-type="item.type"
          v-on:click="emitAdd(item); onSelectSetColor($event)">
          <span>{{ item.getNameWithPrefix() }}</span>
        </button>
        <span>{{ item.typeName }}</span>
      </template>
    </picker-items>
    <div class="patient-documents">
      <iframe
        class="patient-documents__print"
        ref="pdfView"
        title="pdfView"
      />
      <button
        v-if="isShowInfo"
        class="patient-documents__info-need-completed button-action"
        type="button"
        v-bind:disabled="isAwaitRequest"
        v-on:click="showPatientPersonalData">
        Необходимо заполнить все личные данные пациента
      </button>
      <div class="patient-documents__buttons">
        <button
          class="patient-documents__button-make"
          type="button"
          v-on:click="onShowTemplatePickerDialog">Добавить документ</button>
        <button
          class="patient-documents__button-white"
          type="button"
          v-on:click="onShowNdflCertificateOptions">Справка для налоговой</button>
        <router-link
          class="patient-documents__button-white"
          v-bind:to="navigationToRegistry"
        >Реестр выданных справок</router-link>
      </div>
      <input-text-search
        class="patient-documents__search"
        v-bind:value="searchQuery"
        v-on:input="onInputSearchQuery"
        placeholder="Введите название документа"
      />
      <div class="patient-documents__table" v-if="isTemplateListNotEmpty">
        <div class="patient-documents__table__head">
          <input-sort
            class="patient-documents__table__cell sort"
            v-bind:class="{ selected: !!sortByDate }"
            v-bind:title="sortByDateTitle"
            v-bind:value="sortByDate"
            v-on:input="onSortByDate"
          >
            Дата создания
          </input-sort>
          <div class="patient-documents__table__cell">
            Название документа
          </div>
          <div class="patient-documents__table__cell">
            Тип документа
          </div>
          <div class="patient-documents__table__cell">
            № Договора
          </div>
        </div>
        <div
          class="patient-documents__table__row"
          v-bind:key="`${template.type}-${index}`"
          v-for="(template, index) in patientTemplates"
        >
          <div class="patient-documents__table__cell">{{ template.created_date }}</div>
          <div class="patient-documents__table__cell">{{ template.name }}</div>
          <div class="patient-documents__table__cell">{{ template.type_name }}</div>
          <div
            v-if="template.is_contract"
            class="patient-documents__table__cell cell-documents-extended">
            <label class="cell-documents-extended__label" data-sign="№">
              <input
                class="cell-documents-extended__input"
                aria-label="Ввод номера"
                type="text"
                v-bind:min="1"
                v-model="template.number"
                v-on:blur="updateContractTemplateNumber(template.id, $event)"
              />
            </label>
            <div class="patient-documents__table__buttons">
              <button
                class="patient-documents__table__button-download"
                title="Скачать"
                type="button"
                v-on:click="downloadContract(template)"
              >Скачать</button>
              <button
                v-if="!isMobile"
                class="patient-documents__table__button-print"
                title="Печать"
                type="button"
                v-on:click="printContract(template)"
              />
              <button
                class="patient-documents__table__button-delete"
                title="Удалить"
                type="button"
                v-on:click="deleteDocument(template)"
              />
            </div>
          </div>
          <div class="patient-documents__table__cell patient-documents__table__buttons" v-else>
            <button
              class="patient-documents__table__button-download"
              title="Скачать"
              type="button"
              v-on:click="onClickDownloadDocumentButton(template)"
            >Скачать</button>
            <button
              v-if="!isMobile"
              class="patient-documents__table__button-print"
              title="Печать"
              type="button"
              v-on:click="onClickPrintDocumentButton(template)"
            />
            <button
              class="patient-documents__table__button-delete"
              title="Удалить"
              type="button"
              v-on:click="deleteDocument(template)"
            />
          </div>
        </div>
      </div>
      <support-contacts
        v-else-if="!isAwaitRequest"
        class="patient-documents__support"
        v-bind:title="titleSupportContacts"
        v-bind:is-show-mini-button-whats-app="true"
        v-bind:is-show-large-button-whats-app="false"
      />
    </div>
    <side-slide-transition>
      <side-dialog
        v-if="showForm"
        v-on:cancel="showForm = false"
        label="Персональные данные пациента">
        <form
          class="patient-documents__form"
          v-on:submit.prevent="onSubmit">
          <form-identification
            v-on:on-model-update="onUpdateIdentification"
            :input-errors=inputErrors
            :init-identification=identification
            :is-show-inn="true"
          />
          <div class="patient-documents__form__buttons">
            <button
              class="patient-documents__form__button-cancel"
              type="button"
              v-on:click="showForm = false">Отмена</button>
            <button
              class="patient-documents__form__button-submit"
              type="submit"
              v-bind:disabled="isAwaitRequest">Сохранить</button>
          </div>
        </form>
      </side-dialog>
    </side-slide-transition>
  </patient-profile>
</template>

<script>
import { List } from 'monet';
import notifierMixin from '@/mixins/notifierMixin';
import saveFileMixin from '@/mixins/saveFileMixin';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import SideDialog from '@/components/SideDialog.vue';
import {
  EditPatientIdentificationForeignPasswordRequest,
  EditPatientIdentificationRequest,
  Identification,
} from '@/storage/gateways/PatientGateway';
import SupportContacts from '@/components/SupportContacts.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import mobileMixin from '@/mixins/mobileMixin';
import InputTextSearch from '@/components/InputTextSearch.vue';
import debounce from 'lodash.debounce';
import FormIdentification from '@/components/FormIdentification.vue';
import PickerItems from '@/components/PickerItems.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import SelectContractNumberModal from '@/components/SelectContractNumberModal.vue';
import InputSort from '@/components/InputSort.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import HelpIcon from '@/components/HelpIcon.vue';

/**
 * @description Название события выбран номер договора.
 * @type {string}
 */
const NAME_EVENT_SELECTED_CONTRACT_NUMBER = 'on-selected-contract-number';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);
/**
 * @description Текст кнопки помощи - "Доступность документа для филиалов".
 * @type {string}
 */
const helpTextGlobalDocument = 'Документ будет доступен во всех филиалах и иметь юридическую силу в каждом их них.';

/**
 * @description Примесь формы справки НДФЛ.
 * @type {object}
 */
const formNdlMixin = {
  ndflTypeXml: 'xml',
  ndflTypeDoc: 'doc',
  computed: {
    reportingYears() {
      return this
        .reportingYearList
        .map((year) => ({ year, isSelected: year === this.selectedReportingYear }));
    },
    reportingTypes() {
      return this
        .reportingTypeList
        .map(
          ({ name, value }) => ({ name, value, isSelected: value === this.selectedReportingType }),
        );
    },
  },
  data() {
    return {
      isShownNdflCertificateOptionForm: false,
      /**
       * @description Показывать ли модалку с выбором номера договора.
       * @type {boolean}
       */
      isSelectContractNumberModal: false,
      /**
       * @description Id шаблона.
       * @type {string}
       */
      templateId: '',
      reportingYearList: [],
      selectedReportingYear: '',
      selectedReportingType: this.$options.ndflTypeDoc,
      /**
       * @description Удостоверение личности.
       * @type {Identification}
       */
      identification: new Identification(),
      isShownContextContractsDialog: false,
      reportingTypeList: [
        {
          name: 'Текстовый',
          value: this.$options.ndflTypeDoc,
        },
        {
          name: 'Электронный',
          value: this.$options.ndflTypeXml,
        },
      ],
    };
  },
  methods: {
    /**
     * @description Получить опции для формировании справки НДФЛ.
     * @returns {void}
     */
    onShowNdflCertificateOptions() {
      const date = new Date();
      const currentYear = date.getFullYear();
      const years = [];
      for (let i = 3; i >= 0; i -= 1) {
        years.push(currentYear - i);
      }
      this.reportingYearList = years;
      this.selectedReportingYear = currentYear;
      this.isShownNdflCertificateOptionForm = true;
    },
    /**
     * @description Обработать отправку формы с опциями для формировании справки НДФЛ.
     * @returns {void}
     */
    onSubmitNdflCertificateOptionsForm() {
      this.isShownNdflCertificateOptionForm = false;
      this.$router.push({
        name: 'ClinicPanelNdflCertificateCreation',
        params: { id: this.patientId },
        query: { year: this.selectedReportingYear, type: this.selectedReportingType },
      });
    },
  },
};

/**
 * @description Примесь шаблонов документов.
 * @type {object}
 */
const templatesMixin = {
  data() {
    return {
      shownTemplatePicker: false,
      /**
       * @description Список шаблонов.
       * @type []
       */
      templates: [],
      /**
       * @description Список удаленных шаблонов.
       * @type []
       */
      deleteTemplates: [],
      /**
       * @description Отображать на всех филиалах.
       * @type {boolean}
       */
      showAllBranches: false,
    };
  },
  methods: {
    /**
     * @description Обработать показ модального окна выбора шаблонов.
     * @returns {void}
     */
    onShowTemplatePickerDialog() {
      this.shownTemplatePicker = true;
    },
    /**
     * @description Отключить подсветку у удаленных документов.
     * @param {function} resetColorCb Обратный вызов.
     * @returns {void}
     */
    onResetBacklightTheButtons(resetColorCb) {
      this.deleteTemplates?.forEach(({ id, type }) => {
        const buttonSelector = `.picker__item__button[data-id="${id}"][data-type="${type}" i] span`;
        resetColorCb(buttonSelector);
      });
      this.deleteTemplates.length = 0;
    },
    /**
     * @description Получить список шаблонов.
     * @param {string} search
     * @returns {void}
     */
    fetchTemplates(search = '') {
      this
        .$documentTemplateGateway
        .viewList(
          search,
        ).then((result) => {
          result.forEach((templates) => {
            this.templates = templates;
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
        });
    },
    /**
     * @description Обработать добавление шаблона документа на пациента.
     * @param item
     * @returns {Promise<void>}
     */
    async onAddTemplate(item) {
      const patientTemplate = this
        .patientTemplates
        .find(
          (template) => template.type === item.type && template.name === item.name,
        ).orNull();
      if (patientTemplate !== null) {
        const dialog = await this.showAcceptDialog('Данный документ уже прикреплен к пациенту. Продолжить?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      }
      if (item.isSample) {
        this
          .$documentTemplateGateway
          .addPatientTemplateBySample(
            this.patientId,
            item.id,
            item.type,
            this.showAllBranches,
          ).then((result) => {
            result.forEach((response) => {
              this.notifySuccess(response.message);
              this.fetchPatientTemplates();
            });
            result.forEachLeft((error) => {
              this.notifyFail(error.getTitle());
            });
          });
      } else {
        this
          .$documentTemplateGateway
          .addPatientTemplate(
            this.patientId,
            item.id,
            item.type,
            this.showAllBranches,
          ).then((result) => {
            result.forEach((response) => {
              this.notifySuccess(response.message);
              this.fetchPatientTemplates();
            });
            result.forEachLeft((error) => {
              this.notifyFail(error.getTitle());
            });
          });
      }
    },
  },
};

export default {
  computed: {
    addressInputErrors: resolveInputErrors('address'),
    medicalCardNumberErrors: resolveInputErrors('medical-card-number'),
    passportNumberErrors: resolveInputErrors('passport-number'),
    passportSerialErrors: resolveInputErrors('passport-serial'),
    passportWhoIssuedErrors: resolveInputErrors('passport-who-issued'),
    patientId: ({ $route }) => $route.params.id,
    phoneErrors: resolveInputErrors('phone'),
    isShowInfo({ arePersonalDataRequired, isAwaitCheckPersonalDataRequest }) {
      return !isAwaitCheckPersonalDataRequest && arePersonalDataRequired;
    },
    sortByDateTitle() {
      if (!this.sortByDate) {
        return 'Отсортировать по дате';
      }
      if (this.sortByDate === 'asc') {
        return 'Отсортировать по дате в обратном порядке';
      }
      return 'Без сортировки';
    },
    /**
     * @description Отображать заголовок в выборе документа.
     * @returns {boolean}
     */
    shownHeaderDocumentPicker() {
      return this.patientUnderFifteen || this.hasBranchSystem;
    },
    /**
     * @description Имеется филиальная система.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Договора пациента.
     * @returns {Array}
     */
    patientContracts() {
      return this
        .patientTemplates
        .toArray()
        .filter((item) => item.is_contract)
        .map((item) => ({
          value: item.id,
          title: item.number,
        }));
    },
    /**
     * @description Список шаблонов не пустой.
     * @type {boolean}
     */
    isTemplateListNotEmpty: ({ isAwaitRequest, patientTemplates }) => (
      !isAwaitRequest && patientTemplates.size() !== 0
    ),
    /**
     * @description Навигация до реестра справок.
     */
    navigationToRegistry() {
      return {
        name: 'ClinicPanelRegistryNdflCertificateList',
        params: {
          initialPatientId: +this.patientId,
        },
      };
    },
    /**
     * @description Маска ввода серии.
     * @returns {string[]|function}
     */
    serialMask(self) {
      if (self.identification.type === 'passport') {
        return '## ##';
      }
      if (self.identification.type === 'birth_certificate') return 'XXXXXXX';
      return 'XXXXXXX';
    },
    identificationTypeInputError: resolveInputErrors('identification.type'),
    innInputErrors: resolveInputErrors('identification.inn'),
    livingAddressInputError: resolveInputErrors('identification.livingAddress'),
    numberInputError: resolveInputErrors('identification.number'),
    serialInputError: resolveInputErrors('identification.serial'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
    whoIssuedInputError: resolveInputErrors('identification.who_issued'),
    addressInputError: resolveInputErrors('identification.address'),
  },
  components: {
    SelectContractNumberModal,
    FormIdentification,
    InputTextSearch,
    ModalDialog,
    PatientProfile,
    SideDialog,
    SideSlideTransition,
    SupportContacts,
    PickerItems,
    InputSort,
    InputCheckbox,
    HelpIcon,
  },
  created() {
    this.checkPersonalDataCompleteness();
    this.fetchPatientTemplates();
    this.fetchTemplates();
  },
  data() {
    return {
      /**
       * @description Необходимо заполнить все личные данные пациента.
       * @type {boolean}
       */
      arePersonalDataRequired: false,
      sortByDate: '',
      /**
       * @description Список шаблонов пациентов.
       * @type {List}
       */
      patientTemplates: List(),
      /**
       * @description Показывать форму заполнения личных данных пациента.
       * @type {boolean}
       */
      showForm: false,
      /**
       * @description Пациент младше 15.
       * @type {null|Object}
       */
      patientUnderFifteen: false,
      personal: {
        address: '',
        medicalCardNumber: '',
        passportNumber: '',
        passportSerial: '',
        passportWhoIssued: '',
        phone: '',
      },
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Ожидание завершения запроса проверки заполненности личных данных.
       * @type {boolean}
       */
      isAwaitCheckPersonalDataRequest: false,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Заголовок блока контактов поддержки.
       * @type {string}
       */
      titleSupportContacts: 'Для автозаполнения и скачивания документов отправьте нам шаблоны '
        + 'документов вашей клиники (договор, согласие на обработку персональных данных и т.д.), '
        + 'мы сами загрузим их в МИС. \n\n Ваш менеджер Татьяна',
      /**
       * @description Удостоверение личности.
       * @type {Identification}
       */
      identification: new Identification(),
      searchQuery: '',
    };
  },
  methods: {
    debounceFetchPatientTemplates: debounce(function _() { this.fetchPatientTemplates(); }, 300),
    /**
     * @description Обработать сортировку по дате.
     * @param {string} order
     * @returns {void}
     */
    onSortByDate(order) {
      this.sortByDate = order;
      this.debounceFetchPatientTemplates();
    },
    /**
     * @description Обработать событие выбора номера договора.
     * @param {number} contractNumber
     * @returns {void}
     */
    onSelectContractNumber(contractNumber) {
      this.$emit(NAME_EVENT_SELECTED_CONTRACT_NUMBER, contractNumber);
      this.onCloseSelectModal();
    },
    /**
     * @description Обработать событие закрытия модального окна.
     * @returns {void}
     */
    onCloseSelectModal() {
      this.isSelectContractNumberModal = false;
    },
    /**
     * @description Обновление удостоверения личности
     * @param newIdentification {Identification}
     */
    onUpdateIdentification(newIdentification) {
      this.identification = newIdentification;
    },
    /**
     * @description Маска мед. карты.
     * @returns {void}
     */
    cardNumberMask(value) {
      return [value.replace(/[^0-9-—/]/, '').substring(0, 20)];
    },
    /**
     * @description Проверить заполненность личных данных пациента.
     * @returns {void}
     */
    checkPersonalDataCompleteness() {
      this.isAwaitCheckPersonalDataRequest = true;
      this.$patientGateway.checkIdentificationCompleteness(this.patientId).then((result) => {
        result.forEach((list) => {
          this.arePersonalDataRequired = list.length !== 0;
        });
        this.isAwaitCheckPersonalDataRequest = false;
      });
    },
    /**
     * @description Скачать договор.
     * @param {Object} template Шаблон договора.
     * @returns {void}
     */
    async downloadContract(template) {
      const { id } = template;
      const templateId = template.template_id;
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const currentTemplate = this.patientTemplates.find((item) => item.id === id);
        const name = currentTemplate.fold('Договор')((item) => item.name);
        this.saveFile(response, `${name}.doc`);
        this.fetchPatientTemplates();
      };
      const response = await this.$patientGateway.generateContractFromTemplateForDownload(
        this.patientId,
        templateId,
        template.number,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Скачать документы.
     * @param {Object} template   Шаблон.
     * @param {string} contractId Идентификатор договора.
     * @returns {void}
     */
    async downloadDocument(template, contractId = '') {
      const { id } = template;
      const templateId = template.template_id;
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const currentTemplate = this.patientTemplates.find((item) => item.id === id);
        const name = currentTemplate.fold('Документ')((item) => item.name);
        this.saveFile(response, `${name}.doc`);
      };
      const response = await this.$patientGateway.generateDocumentFromTemplateForDownload(
        this.patientId,
        templateId,
        contractId,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Получить список шаблонов по пациенту.
     * @returns {void}
     */
    fetchPatientTemplates() {
      this.isAwaitRequest = true;
      this
        .$documentTemplateGateway
        .viewPatientList(
          this.patientId,
          this.searchQuery,
          this.sortByDate,
        ).then((result) => {
          result.forEach(({ list, patientUnderFifteen }) => {
            this.patientTemplates = List.fromArray(list);
            this.patientUnderFifteen = patientUnderFifteen;
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать ввод запроса.
     * @type {string} value
     * @returns {void}
     */
    onInputSearchQuery(value) {
      this.searchQuery = value;
    },
    /**
     * @description Обработать сохранение персональных данных пациента.
     * @returns {void}
     */
    onSubmit() {
      this.isAwaitRequest = true;
      const onSuccess = (response) => {
        this.notifySuccess(response);
        this.inputErrors = {};
        this.showForm = false;
        this.checkPersonalDataCompleteness();
      };
      const onFail = (error) => {
        if (error.causes && error.causes.length > 0) {
          this.notifyFail('Не удалось отправить данные, проверьте правильность заполнения');
          const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
          this.inputErrors = Object.fromEntries(failurePairs);
        } else {
          this.notifyFail(error.title);
        }
      };
      if (this.identification.type === 'foreign-passport') {
        this.sendIdentificationForeignPasswordEditRequest()
          .then((result) => result.fold(onFail, onSuccess))
          .finally(() => {
            this.isAwaitRequest = false;
          });
        return;
      }
      this.sendIdentificationEditRequest()
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обновить номер шаблона договора.
     * @param templateId
     * @param event
     */
    updateContractTemplateNumber(templateId, event) {
      const number = event.target.value;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = () => {
        this.fetchPatientTemplates();
      };
      const response = this.$patientGateway.editContractTemplateNumber(
        this.patientId,
        templateId,
        number,
      );
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Печать договора.
     * @param {number} template Шаблон договора.
     * @returns {void}
     */
    async printContract(template) {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const container = this.$refs.pdfView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
        this.fetchPatientTemplates();
      };
      const response = await this.$patientGateway.generateContractFromTemplateForPrint(
        this.patientId,
        template.template_id,
        template.number,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Добавить данные удаленного документа.
     * @param {number} template_id Идентификатор документа.
     * @param {string} name Наименование документа.
     * @param {string} name Тип документа.
     * @returns {void}
     */
    pushDeletedDocument({ template_id: id, name, type }) {
      this.deleteTemplates.push({ id, name, type });
    },
    /**
     * @description Удалить документ пациента
     *
     * @param {Object} template
     *
     * @returns {Promise<void>}
     */
    async deleteDocument(template) {
      if (template.is_contract) {
        const dialog = await this.showAcceptDialog('Для отправки данных в ЕГИСЗ необходим номер Договора. Удалить документ?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      } else {
        const dialog = await this.showAcceptDialog('Вы действительно хотите удалить документ?');
        if (dialog.result !== DialogResult.YES) {
          return;
        }
      }
      const onFail = (error) => {
        this.notifyFail(error.message);
      };
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.fetchPatientTemplates();
        this.pushDeletedDocument(template);
      };
      const response = await this
        .$documentTemplateGateway
        .deletePatientTemplate(this.patientId, template.id, template.type);
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Обработать событие нажатия на кнопку печати.
     * @param {object} template
     */
    async onClickPrintDocumentButton(template) {
      const isDocument = !template.is_contract;
      const isHasContractNumber = template.is_has_number_contract_variable;
      const isPatientContractsExists = this.patientContracts.length > 0;
      if (isDocument && isHasContractNumber && isPatientContractsExists) {
        this.isSelectContractNumberModal = true;
        const contractId = await new Promise((resolve) => {
          this.$once(NAME_EVENT_SELECTED_CONTRACT_NUMBER, (contract) => {
            resolve(contract);
          });
        });
        this.printDocument(template.template_id, contractId);
      } else {
        this.printDocument(template.template_id);
      }
    },
    /**
     * @description Обработать событие нажатия на кнопку скачать.
     * @param {object} template
     */
    async onClickDownloadDocumentButton(template) {
      const isDocument = !template.is_contract;
      const isHasContractNumber = template.is_has_number_contract_variable;
      const isPatientContractsExists = this.patientContracts.length > 0;
      if (isDocument && isHasContractNumber && isPatientContractsExists) {
        this.isSelectContractNumberModal = true;
        const contractId = await new Promise((resolve) => {
          this.$once(NAME_EVENT_SELECTED_CONTRACT_NUMBER, (contract) => {
            resolve(contract);
          });
        });
        this.downloadDocument(template, contractId);
      } else {
        this.downloadDocument(template);
      }
    },
    /**
     * @description Печать документа.
     * @param {number} templateId Идентификатор шаблона.
     * @param {string} contractId Идентификатор договора.
     * @returns {void}
     */
    async printDocument(templateId, contractId = '') {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (response) => {
        const container = this.$refs.pdfView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      const response = await this.$patientGateway.generateDocumentFromTemplateForPrint(
        this.patientId,
        templateId,
        contractId,
      );
      response.fold(onFail, onSuccess);
    },
    /**
     * @description Показать персональные данные пациента.
     * @returns {void}
     */
    showPatientPersonalData() {
      this.$patientGateway.getIdentification(this.patientId).then((result) => {
        result.forEach((data) => {
          this.inputErrors = {};
          this.identification = data;
          this.showForm = true;
        });
        result.forEachFail(({ title }) => {
          this.notifyFail(title);
        });
      });
    },
    /**
     * @description Скопировать адрес прописки в адрес проживания
     */
    copyAddressToLivingAddress() {
      this.identification.livingAddress = this.identification.address;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationEditRequest() {
      const request = new EditPatientIdentificationRequest(this.identification, this.patientId);
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });

      return result;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности по иностранному паспорту.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationForeignPasswordEditRequest() {
      const request = new EditPatientIdentificationForeignPasswordRequest(
        this.identification,
        this.patientId,
      );
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });
      return result;
    },
  },
  helpTextGlobalDocument,
  mixins: [
    formNdlMixin,
    templatesMixin,
    notifierMixin,
    saveFileMixin,
    mobileMixin,
    builtInDialogMixin,
  ],
  name: 'ClinicPanelPatientDocuments',
  watch: {
    searchQuery: {
      handler: 'debounceFetchPatientTemplates',
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
@use "@/scss/fields";

.contract-number-modal {
  .modal-dialog {
    overflow-y: auto;
  }
}
.patient-documents {
  &__search {
    max-width: 615px;
    margin-bottom: 20px;
  }
  &__table {
    counter-reset: counterEmployees;
    overflow-x: auto;
    &:empty {
      display: none;
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 160px 1fr 1fr 350px;
      grid-gap: 4px;
      align-items: center;
      min-width: 800px;
      font-size: 14px;
      line-height: 17px;
    }
    &__row {
      width: 100%;
      cursor: pointer;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 12px 0;
    }
    &__cell {
      text-align: left;
      margin: 0 8px;
      &.selected {
        color: var(--action-color);
      }
      &.sort {
        text-align: left;
        cursor: pointer;
        display: flex;
        align-items: baseline;
        &:after {
          content: '';
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          width: 10px;
          height: 10px;
          margin: 0 0 0 10px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
    .cell-documents-extended {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 28px;
      &__label {
        position: relative;
        &::before {
          content: attr(data-sign);
          position: absolute;
          top: 50%;
          padding-inline: 10px;
          transform: translateY(-50%);
        }
      }
      &__input {
        @include fields.input-field;
        padding-left: 30px;
        height: 32px;
        max-width: 95px;
      }
    }
    &__buttons {
      display: flex;
      justify-content: flex-end;
      justify-self: end;
      flex-shrink: 0;
      gap: 8px;
      width: min(100%, 210px);
    }
    &__button-download {
      @include buttons.btn-transparent(100%, 32px, 16px);
      max-width: 118px;
      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
      }
    }
    &__button-print {
      display: flex;
      align-items: center;
      margin: 0 0 0 20px;
      &:before {
        content: "";
        background-image: url("@/assets/img/print.svg");
        background-repeat: no-repeat;
        background-size: contain;
        width: 24px;
        height: 24px;
        margin: 0 8px 0 0;
      }
    }
    &__button-delete {
      display: flex;
      align-items: center;
      margin: 0 0 0 20px;
      &:before {
        content: "";
        background-image: url("@/assets/img/cross-blue.svg");
        background-repeat: no-repeat;
        background-size: contain;
        width: 24px;
        height: 24px;
        margin: 0 8px 0 0;
      }
    }
  }
  &__support {
    background-color: transparent !important;
    padding: 0 !important;
    .support-contacts__caption,
    .support-contacts__tel,
    .support-contacts__email {
      font-size: 16px;
      line-height: 25px;
    }
    .support-contacts__button {
      font-size: 16px;
    }
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
    margin-right: 10px;
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      width: 100%;
      margin: 20px 0 0 0;
    }
    &__button-cancel {
      @include buttons.btn-transparent(100%, 56px, 20px);
    }
    &__button-submit {
      @include buttons.btn-blue(100%, 56px, 20px);
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
  &__select {
    position: relative;
    width: 720px;
    max-width: 100%;
    &-input {
      padding: 0 42px;
      background: #ffffff;
      border: 1px solid #c2cfe0 !important;
      border-radius: 4px;
      outline: none;
      height: 40px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      position: relative;
      width: 720px;
      max-width: 100%;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0 !important;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
    }
    &-icon-search {
      position: absolute;
      left: 12px;
      top: 10px;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/search-black.svg");
      background-size: contain;
      width: 20px;
      height: 18px;
    }
    &-icon-file {
      position: absolute;
      right: 1px;
      top: 1px;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/file.svg");
      background-position: center;
      background-color: #eaeff3;
      border-radius: 0 3px 3px 0;
      width: 36px;
      height: 38px;
    }
  }
  &__copy {
    &__button {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      margin: 0 0 2px 0;
      color: var(--unfocus-color);
      &:after {
        content: '';
        background-image: url("@/assets/img/copy-blue.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: 0 0 0 10px;
        width: 15px;
        height: 15px;
      }
    }
  }
  &__buttons {
    display: grid;
    grid-template-columns: repeat(3, minmax(250px, 300px));
    grid-gap: 15px;
    margin: 30px 0 20px 0;
    @media screen and (max-width: 1100px) {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px 15px;
    }
    @media screen and (max-width: 750px) {
      grid-template-columns: 1fr;
    }
  }
  &__button-white {
    @include buttons.btn-transparent(100%, 56px, 16px);
    text-decoration: none;
    @media screen and (max-width: 1100px) {
      max-width: 400px;
    }
  }
  &__button-make {
    max-width: 400px;
    @include buttons.btn-blue(100%, 56px, 16px);
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__info-need-completed {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 16px;
    line-height: 25px;
    color: red;
    &.button-action {
      text-align: left;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
      &:disabled {
        color: var(--unfocus-color);
      }
    }
    &::before {
      content: "";
      background-image: url("@/assets/img/error.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 10px 0 0;
      width: 25px;
      height: 25px;
    }
  }
  &__print {
    display: none;
  }
  &__ndfl-options {
    display: flex;
    flex-direction: column;
    gap: 40px;

    &__list {
      display: flex;
      flex-flow: row wrap;
      gap: 14px;
    }
    &__year {
      background-color: var(--fill-color);
      padding: 26px 43px;
      font-size: 20px;
      border-radius: 4px;

      &.selected {
        border: 2px solid var(--action-color);
        padding: 24px 41px;
      }
    }
    &__type {
      background-color: var(--fill-color);
      padding: 26px 43px;
      font-size: 20px;
      border-radius: 4px;

      &.selected {
        border: 2px solid var(--action-color);
        padding: 24px 41px;
      }
    }
  }
}

.documents-dialog {
  &__warning {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    column-gap: 10px;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: red;
    text-decoration: underline;
    &::before {
      content: "";
      flex-shrink: 0;
      width: 25px;
      height: 25px;
      background-image: url("@/assets/img/error.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  &__general-document {
    display: flex;
    align-items: center;
    align-self: flex-start;
    column-gap: 8px;
    padding-top: 5px;
  }
  &__checkbox {
    display: flex;
    align-items: center;
  }
  &__help {
    width: 24px;
    height: 24px;
  }
}

.picker {
  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    &__button {
      max-width: 400px;
      text-align: left;
      transition: color 0.2s;
      > span.selected {
        color: #0569ac;
      }
      @media (hover: hover) {
        &:hover {
          color: #0076C4;
        }
      }
      &:active {
        color: #0569ac;
      }
    }
  }
}
</style>
